import { Button, Typography } from 'antd';
import styles from './Disclaimer.module.css';
import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';
import { constants } from 'src/app/constants';
import useAuth from 'src/hooks/useAuth';

const { Text } = Typography;

const Disclaimer = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const onAccept = () => {
    localStorage.setItem('disclaimerAccepted', 'true');
    navigate(constants.MAIN_PAGE);
  };

  const onLogoff = () => {
    logout();
  };

  return (
    <div className="flex flex-col align-center justify-center">
      <div className={styles['Disclaimer--TextContainer']}>
        <Text className={styles['Disclaimer--Text']}>
          This system is provided for Jaguar Land Rover (JLR) business purposes only and any
          unauthorised access or use may result in criminal or civil prosecution.
        </Text>
        <br />
        <br />
        <Text className={styles['Disclaimer--Text']}>
          If you encounter any issues, please contact the IT Service Desk. JLR reserves the right to
          monitor the nature and content of any communications on its systems to check compliance
          with JLR Policies and for usage monitoring to modify and improve the system efficacy.
        </Text>
        <br />
        <br />
        <Text className={styles['Disclaimer--Text']}>
          In particular, anyone working for or on behalf of JLR is required to comply at all times
          with Corporate Policy
          <b>
            <i> CP1-004 (Appropriate Use of JLR Computer Resources) </i>
          </b>
          available from the JLR corporate intranet. Please contact the VF Db Help Desk (PLM Help
          Desk): 8726 6137 ( Internal Users) or +44 (0)2476 206137 (External Users) if you require
          any further information.
        </Text>
        <br />
        <br />
      </div>

      <div className="flex align-center justify-center">
        <Button className={classNames(styles['Disclaimer--AcceptButton'])} onClick={onAccept}>
          Accept
        </Button>
        <Button className={classNames(styles['Disclaimer--LogoffButton'])} onClick={onLogoff}>
          Log off
        </Button>
      </div>
    </div>
  );
};

export default Disclaimer;
